import React from 'react';
import cn from 'classname';

import upperFirst from 'lodash/upperFirst';
import filter from 'lodash/filter';
import some from 'lodash/some';

import './main.less';

function Regions({ regions, setRegions }) {
	return (
		<div className='programs-list__regions'>
			<div className='programs-list__regions-flexbox'>
				{regions.map(({ region, isActive }) => (
					<button
						className={cn(isActive && 'active')}
						onClick={() => {
							setRegions(regions.map((o) => o.region !== region ? o : {
								...o,
								isActive: !o.isActive,
								geos: o.geos.map((geo) => ({ ...geo, isActive: !o.isActive }))
							}));
						}}
						key={region}
					>
						{upperFirst(region) || '?'}
					</button>
				))}
			</div>
			{filter(regions, 'isActive').map(({ region, geos }) => (
				<div
					className='programs-list__regions-flex'
					key={region}
				>
					<div className='programs-list__regions-region'>
						{upperFirst(region) || '?'}:
					</div>
					<div className='programs-list__regions-flexbox'>
						{geos.map((geo) => (
							<button
								className={cn(geo.isActive && 'active')}
								onClick={() => {
									const updatedGeos = geos.map((g) => g.id !== geo.id ? g : { ...g, isActive: !g.isActive });

									setRegions(regions.map((o) => o.region !== region ? o : {
										...o,
										isActive: some(updatedGeos, 'isActive'),
										geos: updatedGeos
									}));
								}}
								key={geo.id}
							>
								{geo.name}
							</button>
						))}
					</div>
				</div>
			))}
		</div>
	);
}

export default Regions;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/regions/main.js